var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDumbbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.166992 5.00003C0.166992 4.22336 0.698192 3.57086 1.41708 3.38586V6.6142C0.698192 6.4292 0.166992 5.7767 0.166992 5.00003Z",
    fill: "#407DBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8331 5.00003C16.8331 5.77661 16.3019 6.4292 15.583 6.6142V3.38586C16.3019 3.57086 16.8331 4.22345 16.8331 5.00003Z",
    fill: "#407DBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3337 2.50004V7.50004C14.3337 7.88754 14.3337 8.08129 14.2911 8.24021C14.1755 8.67162 13.8386 9.00854 13.4072 9.12412C13.2482 9.16671 13.0545 9.16671 12.667 9.16671C12.2795 9.16671 12.0857 9.16671 11.9268 9.12412C11.4954 9.00854 11.1585 8.67162 11.0429 8.24021C11.0003 8.08129 11.0003 7.88754 11.0003 7.50004V5.62504H6.00033V7.50004C6.00033 7.88754 6.00033 8.08129 5.95773 8.24021C5.84215 8.67162 5.50522 9.00854 5.07385 9.12412C4.91489 9.16671 4.72115 9.16671 4.33366 9.16671C3.94617 9.16671 3.75243 9.16671 3.59347 9.12412C3.1621 9.00854 2.82517 8.67162 2.70958 8.24021C2.66699 8.08129 2.66699 7.88754 2.66699 7.50004V2.50004C2.66699 2.11255 2.66699 1.91881 2.70958 1.75985C2.82517 1.32848 3.1621 0.991549 3.59347 0.875966C3.75243 0.833374 3.94617 0.833374 4.33366 0.833374C4.72115 0.833374 4.91489 0.833374 5.07385 0.875966C5.50522 0.991549 5.84215 1.32848 5.95773 1.75985C6.00033 1.91881 6.00033 2.11255 6.00033 2.50004V4.37504H11.0003V2.50004C11.0003 2.11255 11.0003 1.91881 11.0429 1.75985C11.1585 1.32848 11.4954 0.991549 11.9268 0.875966C12.0857 0.833374 12.2795 0.833374 12.667 0.833374C13.0545 0.833374 13.2482 0.833374 13.4072 0.875966C13.8386 0.991549 14.1755 1.32848 14.2911 1.75985C14.3337 1.91881 14.3337 2.11255 14.3337 2.50004Z",
    fill: "#407DBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.efe3ee470fceeb6d0206040d4e626657.svg";
export { ForwardRef as ReactComponent };